import React, { useRef, useState } from 'react'
import { DialogOverlay, DialogOverlayFooter, DialogOverlayActions, TextField, Button, Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function ConfirmRemoveDialog({ onClose, onRemove, ...overlay }) {
  const [reason, setReason] = useState('')
  const { t } = useTranslation()
  const focusElementRef = useRef()

  return (
    <DialogOverlay
      focusRef={focusElementRef}
      id="removeConfirmationDialog"
      {...overlay}
      aria-labelledby="form-dialog-title"
      title={t('person.reference.confirmRemove', 'Confirm Remove')}
    >
      <Paragraph size="sm">
        {t('person.relationships.removeConfirmation', 'Are you sure you want to remove this relationship?')}
      </Paragraph>
      <TextField
        ref={focusElementRef}
        label={t('reason', 'Reason')}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmRemoveRelationshipBtn" onClick={() => onRemove(reason)} type="submit" emphasis="high">
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="cancelRemoveRelationshipBtn" onClick={onClose}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
